import { FC, ReactNode } from "react";

import { ThemeProvider } from "@mui/material";

import { useDynamicCanvasTheme } from "@/forms-design-system/Tokens/dynamicCanvasTheme";

export interface FormThemeProviderProps {
  children: ReactNode;
  baseHexColor: string;
  mode: "light" | "dark";
}

/**
 * Same dynamic Form V2 theme as {@link FormProviders} (without Form V2 context or Stripe shell).
 * Use for surfaces that must render form design-system components outside the full form flow (e.g. pledge payment).
 */
export const FormThemeProvider: FC<FormThemeProviderProps> = ({ children, baseHexColor, mode }) => {
  const theme = useDynamicCanvasTheme(baseHexColor, mode);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
